export const CategoryVisibility = {
  isFeaturedCategory: false,
  isSubCategory: false,
};
